import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Callout } from '@radix-ui/themes';
import { useDeliveryContext } from './DeliveryContext';
import { DeliveryItem } from '../../types';

export interface InvalidCalloutProps {
    warningText: string;
}

export const InvalidCallout = <T extends DeliveryItem, P>({
    warningText,
}: InvalidCalloutProps) => {
    const { invalidCount } = useDeliveryContext<T, P>();

    if (invalidCount === 0) return null;

    return (
        <Callout.Root color='amber' size='1'>
            <Callout.Icon>
                <ExclamationTriangleIcon />
            </Callout.Icon>
            <Callout.Text>
                {invalidCount} {warningText}
            </Callout.Text>
        </Callout.Root>
    );
};
